import { produce } from 'immer';
import * as actions from '../constants/action-types';

export default (state = {}, { type, payload }) =>
    produce(state, (draft) => {
        switch (type) {
            case actions.LOADING_INBOUND_STATS:
                draft.loading = payload.loading;

                break;

            case actions.RECEIVED_INBOUND_STATS:
                return {
                    ...draft,
                    ...payload,
                };
        }
    });
